import React, { createContext, useContext, useEffect, useState } from 'react'
import { geoData } from '@fs/zion-config'

const CountryContext = createContext({ country: '' })

export const COUNTRIES_DEV = {
  CHINA: 'CN',
  HONG_KONG: 'HK',
  JAPAN: 'JP',
  TAIWAN: 'TW',
  UNITED_STATES: 'US',
}

export function CountryProvider({ children }) {
  const [country, setCountry] = useState()

  useEffect(() => {
    setCountry(geoData.country)
  }, [])

  const contextValue = React.useMemo(() => ({ country }), [country])
  return <CountryContext.Provider value={contextValue}>{children}</CountryContext.Provider>
}

export function useCountry() {
  return useContext(CountryContext)
}
